module.exports = __webpack_public_path__ + "assets/img/driver-btn-dc9c6cba.png";